import BaseInteraction from './BaseInteraction';
import logger from '../log';
import { SourceType, DeliveryMode } from '../common/constants';
import bindTHEOplayerToWebRTC from '../webrtc/bindTHEOplayerToWebRTC';
import ContentItem from '../api/content/ContentItem';
import { THEOPlayer, THEOSources } from './interfaces';

const { ECDN11, WEBRTC } = DeliveryMode;

const log = logger.getLogger(__filename);

export default class THEOplayerInteraction extends BaseInteraction<THEOPlayer> {
  constructor(player: THEOPlayer) {
    super(player, [ECDN11, WEBRTC]);
  }

  initialize(): void {
    super.initialize();
    log.debug('binding to THEOplayer');
    bindTHEOplayerToWebRTC(this.player, this.binder);
  }

  loader(items: ContentItem[]): ContentItem[] {
    const sources = items.map(i => {
      return {
        src: i.url,
        type: i.data.mime
      };
    });
    this.setSource({ sources });
    return items;
  }

  setSource(sources: THEOSources): void {
    this.player.source = sources;
    this.player.preload = 'auto';
  }

  clearSource(): void {
    log.warn(this.generatePlannedErrorMessage('clearSource', 'THEOplayer'));
    // Implementing this should be as simple as uncommenting this and testing it.
    // this.setSource(null);
  }

  mediaElement(): HTMLMediaElement {
    // the player is used on IE7 and sometimes does not have a real video element.
    return this.player;
  }

  getAllowedSourceTypes(): SourceType[] {
    return [SourceType.HLS, SourceType.DASH];
  }
}
